import { useState, useEffect } from "react";
import Badge from "../../../../../components/Badge/Badge";
import { handleToast } from "../../../../../helper";


// export default function UrlQueryParams({ URLqueryParamData }) {
export default function UrlQueryParams(props) {
  const { URLqueryParamData, customizeState, setCustomizeState, nudgeData } =
  props;
  const [URLquery, setURLquery] = useState(URLqueryParamData);

  // console.log("customizeState",nudgeData)
  useEffect(() => {
    if (nudgeData) {
      const queryParams = nudgeData?.nudgeTrafficSources?.customizeProperties?.queryParams || [];

      if (queryParams) {
        let tempqueryParams = queryParams?.propertyValue?.length;
        if (tempqueryParams) {
          setURLquery(queryParams.propertyValue);
        }
      }
    }
  }, [nudgeData]);

  useEffect(() => {
    let state = {
      ...customizeState,
      nudgeTrafficSources: {
        ...customizeState["nudgeTrafficSources"],
        "queryParams":URLquery,
      },
    };
    setCustomizeState(state);
  }, [URLquery]);

  function handleDeleteUrlQuery(title) {
    // remove referrer
    const newUrlQueryparams = URLquery.filter(UrlQueryParam => UrlQueryParam !== title);

    setURLquery(newUrlQueryparams);
    // save referrer sites
    // saveUrlQueryParams(newUrlQueryparams, 'delete');
    console.log(newUrlQueryparams, 'delete');
  }

  return (
    <div className="ReferrerSites p-2 flex flex-col gap-2 ms-3">
      <div className="ReferrerSites__badges ">
        <p className="ReferrerSites__title h6 font-bold">URL query params (ads user tracking): </p>
        <div className="flex flex-wrap items-center gap-2.5 my-2">
        {
          URLquery.length > 0 &&
            URLquery.map((query, index) => {
              if (query === "HandleEmptyArrayValue") return null;
              return <Badge key={query} title={query} onClose={handleDeleteUrlQuery} index={index} />
            }
            
            )
        }
        </div>

      </div>
      <InputBadge URLquery={URLquery} setURLquery={setURLquery} />
    </div>
  )
}

function InputBadge({ URLquery, setURLquery }) {

  const [queryKey, setQueryKey] = useState('');
  const [queryValue, setQueryValue] = useState('');

  const title = queryKey + '=' + queryValue;

  async function handleSaveUrlQuery() {
    // check for duplicate
    if (URLquery.length > 0 && URLquery.includes(title)) {
      handleToast('error', 'Duplicate referrer site');
      return;
    }
    // check for empty
    if (title.length < 2) {
      handleToast('error', 'Referrer site cannot be empty');
      return;
    }
    // add to referrer sites
    let newUrlQueryParams = [...URLquery];
    newUrlQueryParams.push(title);
    setURLquery(newUrlQueryParams);

    // save referrer sites
    // await saveUrlQueryParams(newUrlQueryParams, 'add');
    console.log(newUrlQueryParams, 'add');
    setQueryKey('');
    setQueryValue('');
  }

  function handleQueryKeyChange(e) {
    setQueryKey(e.target.value);
  }
  function handleQueryValueChange(e) {
    setQueryValue(e.target.value);
  }

  return (
    <div className='Badge px-2 py-2 rounded-lg border-2 bg-opacity-5 border-blue-500 bg-blue-500 text-blue-500 w-full flex  justify-between items-center gap-x-5'>
      <input onChange={handleQueryKeyChange} className='text-sm font-semibold outline-none bg-transparent  placeholder:text-center rounded-md w-full' placeholder="key" value={queryKey} />
      <span>=</span>
      <input onChange={handleQueryValueChange} className='text-sm font-semibold outline-none bg-transparent border-r border-inherit placeholder:text-center rounded-md w-full' placeholder="value" value={queryValue} />
      {/* <BsFillCheckCircleFill onClick={handleSaveUrlQuery} className="cursor-pointer" /> */}
      <button onClick={handleSaveUrlQuery} className="text-white bg-blue-500 p-1.5 px-8 rounded-md " >Add</button>
    </div>
  )
}